import { rem } from "polished"

const cookiesConsent = {
  textColor: ({ theme }) => theme.colors.white,
  borderColor: ({ theme }) => theme.colors.black,
  backgroundColor: ({ theme }) => theme.colors.darkGreen,
  br: rem(8),
  buttonFont: ({ theme }) => theme.fonts.set(`primary`, `semibold`),
  buttonTextColor: ({ theme }) => theme.colors.darkGreen,
  buttonBackgroundColor: ({ theme }) => theme.colors.white,
  buttonBr: rem(5),
}

export default cookiesConsent
